// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-checkMarkBalloon":"jobSearchDetail-checkMarkBalloon","jobSearchDetail-checkMarkBalloon__text":"jobSearchDetail-checkMarkBalloon__text"};